var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentHits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4638_357159)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8915 11.4783C19.963 10.9959 20 10.5023 20 10C20 8.57779 19.7031 7.22492 19.1679 6H24V11.4783H19.8915ZM18.5217 15.2353C19.0795 14.3294 19.4968 13.3278 19.7434 12.2609H24V17.7391H18.5217V15.2353ZM16.3334 17.7391C16.8471 17.3182 17.3182 16.8471 17.7391 16.3334V17.7391H16.3334ZM12.2609 19.7434C13.3278 19.4968 14.3294 19.0795 15.2353 18.5217H17.7391V24H12.2609V19.7434ZM6 19.1679C7.22492 19.7031 8.57779 20 10 20C10.5023 20 10.9959 19.963 11.4783 19.8915V24H6V19.1679ZM24 18.5217H18.5217V24H24V18.5217Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FEFEFE",
    stroke: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1649 3L14.4236 7.05475L11.8354 8.38608L9.94529 5.82868L13.1649 3ZM9.86016 6.0144L11.709 8.51591L10.8122 11.5721L10.151 7.39771L10.1415 7.33747L10.0953 7.29601L9.86544 7.08973L9.82006 6.11725L9.86016 6.0144ZM11.3172 13.0121L11.3295 13.021L12.4598 9.8311L11.3172 13.0121ZM12.462 9.82821L13.7726 9.042L13.7782 9.02863L12.462 9.82821ZM10.6508 11.7092L10.6177 11.7628L10.0626 11.3157L9.87706 7.33884L9.97215 7.42417L10.6508 11.7092ZM11.1652 12.9019L11.1485 12.8898L10.9223 12.5837L10.8782 11.988L11.8844 8.559L14.3503 7.29058L13.8906 8.75379L12.3642 9.68098L12.3104 9.71367L12.2896 9.7717L11.1652 12.9019Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4619 9.82828L13.7726 9.04207L13.7781 9.0287L12.4619 9.82828ZM11.164 12.905L11.1484 12.8899L10.9222 12.5838L10.8782 11.988L11.8844 8.55907L14.3502 7.29065L13.8905 8.75386L12.3642 9.68105L12.3104 9.71374L12.2895 9.77177L11.164 12.905Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1649 3L14.4236 7.05475L11.8354 8.38608L9.94529 5.82868L13.1649 3Z",
    fill: "#5CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60535 8.42949L6.58026 4.47212L8.78969 12.2487L8.70539 12.3651L7.52905 9.17315L5.60535 8.42949ZM10.7619 12.3748L9.65549 11.0533L8.92449 12.0626L6.74946 4.4071L9.97297 7.44152L10.7619 12.3748Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60535 8.42954L6.58026 4.47217L8.61427 11.6313L8.70539 12.3651L7.52905 9.1732L5.60535 8.42954Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8235 16.7342L14.3929 15.997L15.3413 14.5894L12.339 16.1403L11.8235 16.7342ZM12.6024 15.8059L15.1561 14.4868L13.5805 14.6017L12.7896 15.5571L12.6024 15.8059Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4624 16.1402L15.4648 14.5894L14.5163 15.997L11.9469 16.7342L12.4624 16.1402Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49517 16.4394L4.36194 14.6644L7.555 16.0925L7.75522 16.3441L7.98144 16.5627L8.4114 16.9782L5.49517 16.4394ZM6.15844 14.342L7.30278 15.7757L7.3168 15.7933L4.46205 14.5165L6.15844 14.342Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49517 16.3433L4.36194 14.5684L7.555 15.9965L7.75522 16.248L7.98144 16.4666L8.4114 16.8822L5.49517 16.3433ZM7.11586 15.6073L7.30278 15.6796L7.3168 15.6972L7.11586 15.6073Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7023 7.86523L15.867 11.6449L13.2178 11.9649L12.4834 9.83559L12.4908 9.815L15.7023 7.86523ZM12.3855 10.105L13.058 12.0547L11.2396 15.7264L11.4652 13.4146L11.3295 13.0211L11.3483 12.9621L12.3855 10.105ZM11.5749 17.0001L11.1033 17L11.1843 16.2431L13.2157 12.1414L15.719 11.839L11.5749 17.0001Z",
    fill: "#5CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3855 10.1049L13.058 12.0546L11.2395 15.7263L11.4652 13.4145L11.3294 13.0209L11.3481 12.9624L12.3855 10.1049Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5749 16.9999L11.1033 16.9999L11.1444 16.3235L13.2157 12.1413L15.719 11.8389L11.5749 16.9999Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56525 11.8457L7.44039 9.50115L8.46369 12.2702L8.56961 12.5837L8.16241 13.2396L8.56961 14.8137L9.17668 16.4434L6.56525 11.8457ZM7.66268 16.013L8.51897 16.9792L9.27456 16.9792L6.41342 11.9418L4.10222 11.9953L4.77475 12.7542L6.26218 14.2016L7.66268 16.013ZM4 11.8227L6.40217 11.7671L7.32597 9.29225L4.00001 8.01331L4 11.8227Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51897 16.9792L9.27456 16.9792L6.41342 11.9418L4.10222 11.9953L4.77475 12.7542L6.26218 14.2016L7.66268 16.013L8.51897 16.9792ZM4 11.8227L6.40217 11.7671L7.32597 9.29225L4.00001 8.01331L4 11.8227Z",
    fill: "#5CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51893 16.9792L9.27451 16.9792L6.41338 11.9418L4.10217 11.9953L4.77467 12.7541L6.26214 14.2015L7.66268 16.013L8.51893 16.9792Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9798 16.9693L11.3241 13.6257L9.99516 14.7967L10.2984 16.9724L10.9798 16.9693ZM10.1158 16.9723L9.81384 14.8059L8.40527 13.555L9.45536 16.9692L10.1158 16.9723ZM9.89939 14.6444L8.34338 13.2625L9.66486 11.3467L11.3147 13.3973L9.89939 14.6444Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1158 16.9723L9.81384 14.8059L8.40527 13.555L9.45536 16.9692L10.1158 16.9723ZM9.89939 14.6444L8.34338 13.2625L9.66486 11.3467L11.3147 13.3973L9.89939 14.6444Z",
    fill: "#5CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1158 16.9724L9.81385 14.806L8.40527 13.5551L9.45536 16.9693L10.1158 16.9724Z",
    fill: "#0059CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4638_357159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentHits);
export default __webpack_public_path__ + "static/media/Experiment_Hits.12e5f327a22b485044f9cf2ba709759b.svg";
export { ForwardRef as ReactComponent };